export const MODE_VIEW = 0;
export const MODE_EDIT = 1;
export const MODE_ADD = 2;
export const NOTE_TYPE_SIMPLE = false;
export const NOTE_TYPE_TIME = true;
